export const SHOPPAGECONSTANTS = {
  SORTOPTIONS: {
    PRICEHIGHTOLOW: "High to Low",
    PRICELOWTOHIGH: "Low to High",
    PRODUCTNAMEASCENDING: "Product Name A - Z",
    PRODUCTNAMEDESCENDING: "Product Name Z - A",
    CREATEDATDESCENDING: "New to Old",
    CREATEDATASCENDING: "Old to New",
  },
  SHOPPAGINATIONCONSTANTS: {
    SHOP_PRODUCTS_PER_PAGE: 8,
    PRODUCTNAME: "productName",
    CREATEDAT: "createdAt",
  },
};
